// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__lV2uL","vertical":"styles_vertical__xfis8"};